import { FitnessPrescriptionItemRequest, PrescriptionItemStatus } from "@curefit/gmf-common";
import * as React from "react";
import { IPlanActivity } from "../../../models/LCPlanClientModels";
import ModelFactory from "../../../models/ModelFactory";
import { AppConstants } from "../../../utils/AppConstants";
import AppUtils from "../../../utils/AppUtils";
import TemplatedList from "../../TemplatedList";
import CustomHeader, { ICustomHeaderInfo } from "../../utils/CustomHeader";

/**
 * Created by abhinav on 28/01/18.
 */

let LifeStyleEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "activity", display: "ACTIVITY", mandatory: true},
    {label: "frequency", display: "FREQUENCY", mandatory: true},
    {label: "duration", display: "DURATION", mandatory: true},
    {label: "advice", display: "ADVICE"},
    {label: "reminder", display: "REMINDER"},
];

const LifestyleGuidelinesHeaderInfos: ICustomHeaderInfo[] = [
    { label: "guidelines", display: "GUIDELINES" }
];


export interface FitnessPlanEditorProps {
    consultationType?: string,
    updatedFitnessPlans: {item: IPlanActivity}[],
    updateFitnessPlans: (updatedLifeStyle: {item: IPlanActivity}[]) => void,
    fetchFitnessActivities: (input: string) => Promise<any>,
    updatedFitnessGuidelines: {item: string}[],
    updateFitnessPlanGuidelines: (updatedGuidelines: {item: string}[]) => void,
    consultationId: number,
    doctorId: number,
    doctorType: string,
    doctorName: string
}

class FitnessPlanEditor extends React.Component<FitnessPlanEditorProps> {

    constructor(props: FitnessPlanEditorProps) {
        super(props);
    }

    onLifeStyleRemove = (index: number) => {
        let currUpdatedLifeStyle = Object.assign([], this.props.updatedFitnessPlans);
        currUpdatedLifeStyle.splice(index, 1);
        this.props.updateFitnessPlans(currUpdatedLifeStyle);
    }

    onLifeStyleChange = (updatedLifeStyle: IPlanActivity, index: number) => {
        let currUpdatedLifeStyle = Object.assign([], this.props.updatedFitnessPlans);
        currUpdatedLifeStyle[index] = updatedLifeStyle;
        this.props.updateFitnessPlans(currUpdatedLifeStyle);
    }

    _handleGuidelineOnChange = (updatedGuideline: {item: string}, index: number) => {
        let currentUpdatedGuidelines = [...this.props.updatedFitnessGuidelines];
        currentUpdatedGuidelines[index] = updatedGuideline;
        this.props.updateFitnessPlanGuidelines(currentUpdatedGuidelines);
    };

    _handleGuidelineOnRemove = (index: number) => {
        let currentUpdatedGuidelines = [...this.props.updatedFitnessGuidelines];
        currentUpdatedGuidelines.splice(index, 1);
        this.props.updateFitnessPlanGuidelines(currentUpdatedGuidelines);
    };

    _getGuidelineMeta = () => {
        return {
            doctorId: this.props.doctorId.toString(),
            doctorType: AppUtils.getPlanMetaDoctorType(this.props.doctorType),
            doctorName: this.props.doctorName,
            consultationId: this.props.consultationId
        }
    }

    render() {
        let consultationType = this.props.consultationType;
        let fetchFitnessActivities = this.props.fetchFitnessActivities;
        let guidelinesListItems = this.props.updatedFitnessGuidelines || [];
        return (
            <div className="patient-fitness-plan-editor">
                <div className={"patient-fitness-plan-guidelines-container"}>
                    <CustomHeader headerInfos={LifestyleGuidelinesHeaderInfos} rootCls={"patient-fitness-plan-guidelines"}/>
                    <TemplatedList templateName={"fitnessPlanGuidelines"} listItems={guidelinesListItems} commonProps={{getGuidelineMeta: this._getGuidelineMeta}} defaultItem={{item: ""}} onItemChange={this._handleGuidelineOnChange} onItemRemove={this._handleGuidelineOnRemove}/>
                </div>
                <div className={"patient-fitness-plan-container"}>
                    <CustomHeader headerInfos={LifeStyleEditorHeaderInfos} rootCls={"patient-fitness-plan"}/>
                    <TemplatedList templateName={"fitnessPlan"} commonProps={{consultationType, fetchFitnessActivities}}
                                   defaultItem={{item: ModelFactory.createNewFitnessPlanPrescriptionItem()}}
                                   listItems={this.props.updatedFitnessPlans}
                                   onItemRemove={this.onLifeStyleRemove}
                                   onItemChange={this.onLifeStyleChange}/>
                </div>
            </div>
        );
    }
}

export default FitnessPlanEditor